export default __webpack_public_path__ + "static/media/loading.c138fe23.svg";